import React, { FunctionComponent, ReactElement } from 'react';
import { Box } from '@material-ui/core';
import { GetCustomizeCarModel_customizeCar } from '../../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import ModelSelectorItemContainer from '../modelSelectorItem/ModelSelectorItemContainer';

export interface IModelSection {
  selectedCarModelData: GetCustomizeCarModel_customizeCar;
  model: string;
  detailsSlot?: ReactElement;
}

const ModelSection: FunctionComponent<IModelSection> = ({ model, detailsSlot }) => {
  return (
    <Box data-test={'model'} width={1}>
      <ModelSelectorItemContainer modelName={model} selected={true} id={'1'} detailsSlot={detailsSlot} />
    </Box>
  );
};

export default ModelSection;
